/*
 *  Links List - Create a list of links, and then share it!
 *  Copyright (c) Luke Denton
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation; either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { db } from "@utils/FirebaseListeners";

export default {
  name: "LatestUpdates",
  props: [
    'isOpen'
  ],
  methods: {
    clearUpdates() {
      // Clear the latest updates modal by passing the latest release value, which won't ever be smaller than any of the updates, so the modal will close
      const lastUpdateId = this.$store.getters.updates[0].release;
      this.$store.dispatch('setLatestUpdates', { lastUpdateId });
      db.ref(`users/${this.$store.getters.user.uid}/lastUpdateId`).set(lastUpdateId);
    }
  }
};
